<template>
  <div class="tab__container" :class="{ stretch }">
    <div
      v-for="item of list"
      :key="item.label"
      class="tab__item"
      :class="{ 'is-active': value == item.value }"
      :style="{ 'width': item_width }"
      @click="
        $emit('input', item.value);
        $emit('tab-click');
      "
    >
      {{ item.label }}
    </div>

    <!-- <slot></slot> -->
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: {
    stretch: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: "",
    },
    item_width: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>


<style scoped lang="scss">
.tab__container {
  display: flex;
  font-size: 15px;
  line-height: 60px;
  height: 60px;
  box-sizing: border-box;
  font-weight: bold;
  border-bottom: 1px solid $borderPlainColor;
  &.stretch {
    .tab__item {
      flex-grow: 1;
      text-align: center;
    }
  }

  .tab__item {
    padding: 0 32px;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    position: relative;
    top: 1px;
    &.is-active {
      background-color: #fff;
      color: $warningColor;
      border-bottom: 4px solid $warningColor;
    }
  }
}
</style>

